import React from "react"
import { notification } from "antd"
import api from "src/api"

export function useManageItems(getItems, onSuccessEdit, onSuccessCreate) {
    const [editData, setEditData] = React.useState(null)

    async function onEditItem(id) {
        const { data } = await api.get(`product-set/${id}`)
        const formattedData = formattedItem(data.product)
        setEditData(formattedData)
        onSuccessEdit()
    }

    async function onCreate(values) {
        try {
            await api.post("product-set", values)

            notification.success({ message: "Набор обновлен" })
            onSuccessCreate()
            getItems()
        } catch (error) {
            console.log("Ошибка добавления", error)
            notification.error({ message: "Ошибка добавления" })
            throw error
        }
    }

    async function onSaveEdit(values, id) {
        try {
            await api.post(`product-set/${id}`, values)

            notification.success({ message: "Набер изменен" })
            getItems()
            onSuccessEdit()
            resetData()
        } catch (error) {
            console.log("Ошибка изменения", error)
            notification.error({ message: "Ошибка изменения" })
            throw error
        }
    }

    async function onDelete(id) {
        try {
            await api.delete(`product-set/${id}`)

            notification.success({ message: "Набор удален" })
            getItems()
        } catch (error) {
            console.log("Ошибка удаления", error)
            notification.error({ message: "Ошибка удаления" })
            throw error
        }
    }

    function resetData() {
        setEditData(null)
    }

    return { editData, resetData, onSaveEdit, onCreate, onDelete, onEditItem }
}

function formattedItem(item) {
    return {
        ...item,
        virtualCategories: item.virtualCategories.map((category) => ({
            virtualCategoryId: category.id,
            mainProductId: category.mainProductInSetId
        })),
        dashboardProductCategoryIds: item.dashboardProductCategories.map((category) => category.id),
        dashboardProductLabelIds: item.dashboardProductLabels.map((label) => label.id)
    }
}
